import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { BackLink, CTA, Description, Image, Title } from "@/ui";

export default function HeaderTextOverlay({ className, containerClassName, title, img, description, cta, back, bgColor, textColor, button, align }) {
  const alignClass = align === "right" ? "text-end" : "text-start";
  return (
    <div className={clsx(className, bgColor, classes.header, { "has-img": img })}>
      <img src={img} className={classes.header__img} alt="Header image" />
      <div className={clsx(classes.header__body, "py-3 p-md-5")}>
        <Container className={containerClassName}>
          <Row>
            <Col xs={12} md={8}>
              <BackLink back={back} />
              <Title className={clsx("mb-0", textColor, alignClass)} title={title} tag="h1" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Description className={clsx("mt-4", textColor)} description={description} />
              {cta && <CTA className="mt-4" label={cta.label} href={cta.href} variant={cta.variant} />}
              {button?.map((btn, k) => (
                <CTA
                  key={k}
                  label={btn.label}
                  href={btn.href}
                  className="mt-4"
                  variant={btn.variant}
                  target={btn.open_in_new_tab ? "_blank" : undefined}
                />
              ))}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

HeaderTextOverlay.defaultProps = {
  className: "bg-primary text-white",
  containerClassName: "mw-xxl",
  title: null,
  img: null,
  contain: false,
  description: null,
  cta: null,
  back: null,
  align: "left",
};

HeaderTextOverlay.propTypes = {
  className: PropTypes.string,
  title: PropTypes.any,
  img: PropTypes.string,
  description: PropTypes.any,
  cta: PropTypes.shape({
    className: PropTypes.string,
    label: PropTypes.string,
    href: PropTypes.string,
    variant: PropTypes.string,
  }),
  back: PropTypes.shape({
    path: PropTypes.string,
    placeholder: PropTypes.string,
    href: PropTypes.string,
  }),
};
